export const MAINTENANCE = false

export const BANNER: string = undefined
// export const BANNER: string = "EUPR Tech Update - Automatic Config Reloading May Be Broken"
